import { VuexModule, Module } from "vuex-class-modules"
import { store } from "../../store"
import { Modules } from "../../modules"
import { Status } from "@/models"

export enum ItemStatusActions {
  GET_STATUSES = "GET_STATUSES",
  GET_STATUSES_FOR_FILTER = "GET_STATUSES_FOR_FILTER",
  GET_STATUSES_FOR_PRODUCT_BACKLOG_FILTER = "GET_STATUSES_FOR_PRODUCT_BACKLOG_FILTER",
  GET_STATUS_BY_ID = "GET_STATUS_BY_ID",
  GET_STATUS_BY_IDS = "GET_STATUS_BY_IDS",
  GET_IN_PROGRESS_STATUSES = "GET_IN_PROGRESS_STATUSES"
}

@Module
class ItemStatusModule extends VuexModule {
  statuses = [
    {
      id: "NOT_STARTED",
      label: "Not Started",
      statusPriority: 15,
    },
    {
      id: "IN_OPS",
      label: "In Ops",
      statusPriority: 16,
    },
    {
      id: "OPS_DONE",
      label: "Ops Done",
      statusPriority: 15,
    },
    {
      id: "IN_UI_UX",
      label: "In UI/UX",
      statusPriority: 14,
    },
    {
      id: "UI_UX_DONE",
      label: "UI/UX Done",
      statusPriority: 13,
    },
    {
      id: "IN_DESIGN",
      label: "In Design",
      statusPriority: 12,
    },
    {
      id: "DESIGN_COMPLETED",
      label: "Design Done",
      statusPriority: 11,
    },
     {
      id: "IN_DISCOVERY",
      label: "Discovery",
      statusPriority: 22,
    },
    {
      id: "IN_DEVELOPMENT",
      label: "In Development",
      statusPriority: 10,
    },
    {
      id: "DEVELOPMENT_DONE",
      label: "Development Done",
      statusPriority: 9,
    },
    {
      id: "IN_QA",
      label: "In QA",
      statusPriority: 8,
    },
    {
      id: "TESTING_COMPLETE",
      label: "QA Done",
      statusPriority: 7,
    },
    {
      id: "SCHEDULED_FOR_DEPLOYMENT",
      label: "Scheduled for Deployment",
      statusPriority: 6,
    },
    {
      id: "DEPLOYED_TO_STAGING",
      label: "In Staging",
      statusPriority: 5,
    },
    {
      id: "DEPLOYED_TO_PRODUCTION",
      label: "In Production",
      statusPriority: 4,
    },
    {
      id: "DONE",
      label: "Done",
      statusPriority: 3,
    },
    {
     id: "CLIENT_REVIEW",
     label: "Client Review",
      statusPriority: 20,
    },
    {
     id: "PM_REVIEW",
     label: "PM Review",
      statusPriority: 21,
    },
    {
      id: "IN_PROGRESS",
      label: "Start",
      statusPriority: 19,
    },
    {
      id: "BLOCKED",
      label: "Blocked",
      statusPriority: 2,
    },
    {
      id: "OBSOLETE",
      label: "Obsolete",
      statusPriority: 1,
    },
    {
      id: "RESUME",
      label: "Resume",
      statusPriority: 17,
    },
    {
      id: "UNBLOCKED",
      label: "Unblocked",
      statusPriority: 16,
    },
    {
      id: "RESTORE",
      label: "Restore",
      statusPriority: 17,
    },
    {
      id: "RE_OPEN",
      label: "Re-open",
      statusPriority: 18,
    },
    {
      id: "DISCOVERY_DONE",
      label: "Discovery done",
      statusPriority: 18,
    },
    { id: "IN_UX", label: "In UX", statusPriority: 17 },
    { id: "UX_DONE", label: "UX Done", statusPriority: 16 },
    { id: "IN_UI_DESIGN", label: "In UI Design", statusPriority: 15 },
    { id: "UI_DESIGN_DONE", label: "UI Design Done", statusPriority: 14 },
    { id: "TESTING", label: "Testing", statusPriority: 13 },
    { id: "UI_TESTING_DONE", label: "Testing Done", statusPriority: 12 },
    { id: "DELIVERY", label: "Delivery", statusPriority: 11 },
    { id: "DELIVERY_DONE", label: "Delivery Done", statusPriority: 10 },
    { id: "DEV_HANDOFF", label: "Dev Handoff", statusPriority: 9 },
    { id: "HANDOFF_DONE", label: "Handoff Done", statusPriority: 8 },
    { id: "INFRASTRUCTURE", label: "Infrastructure", statusPriority: 17 },
    { id: "INFRASTRUCTURE_DONE", label: "Infrastructure Done", statusPriority: 16 },
    { id: "CI_CD_PIPELINE", label: "CI/CD Pipeline", statusPriority: 15 },
    { id: "PIPELINE_DONE", label: "Pipeline Done", statusPriority: 14 },
    { id: "SECURITY", label: "Security", statusPriority: 13 },
    { id: "SECURITY_DONE", label: "Security Done", statusPriority: 12 },
    { id: "MITIGATION", label: "Mitigation", statusPriority: 12 },
    { id: "MITIGATION_DONE", label: "Mitigation Done", statusPriority: 11 },
    { id: "REMEDIATING", label: "Remediating", statusPriority: 11 },
    { id: "REMEDIATION_DONE", label: "Remediation Done", statusPriority: 10 },
    { id: "IN_TESTING", label: "In Testing", statusPriority: 10 },
    { id: "TESTING_DONE", label: "Testing Done", statusPriority: 9 },
    { id: "IN_REVIEW", label: "In Review", statusPriority: 9 },
    { id: "REVIEW_DONE", label: "Review Done", statusPriority: 8 },
    { id: "OBSERVABILITY", label: "Observability", statusPriority: 11 },
    { id: "OBSERVABILITY_DONE", label: "Observability Done", statusPriority: 10 },
    { id: "ALERTING", label: "Alerting", statusPriority: 9 },
    { id: "ALERTING_DONE", label: "Alerting Done", statusPriority: 8 },
    { id: "PERFORMANCE", label: "Performance", statusPriority: 7 },
    { id: "PERFORMANCE_DONE", label: "Performance Done", statusPriority: 6 },
    { id: "COST_OPTIMIZATION", label: "Cost Optimization", statusPriority: 5 },
    { id: "OPTIMIZATION_DONE", label: "Optimization Done", statusPriority: 4 },
    { id: "DOCUMENTATION", label: "Documentation", statusPriority: 3 },
    { id: "DOCUMENTATION_DONE", label: "Documentation Done", statusPriority: 2 },
    {
     id: "IN_RESEARCH",
     label: "Research",
      statusPriority: 31,
    },
    {
     id: "RESEARCH_DONE",
     label: "Research Done",
      statusPriority: 30,
    },
    {
     id: "CONTENT_CREATING",
     label: "Content",
      statusPriority: 29,
    },
    {
     id: "CONTENT_DONE",
     label: "Content Created",
      statusPriority: 28,
    },
    {
     id: "IN_GRAPHIC_DESIGN",
     label: "Graphic Design",
      statusPriority: 27,
    },
    {
     id: "GRAPHIC_DESIGN_DONE",
     label: "Graphics Done",
      statusPriority: 26,
    },
    {
     id: "IN_SEO",
     label: "SEO",
      statusPriority: 25,
    },
    {
     id: "SEO_DONE",
     label: "SEO Done",
      statusPriority: 24,
    },
    {
     id: "IN_SMM",
     label: "SMM",
      statusPriority: 23,
    },
    {
     id: "SMM_DONE",
     label: "SMM Done",
      statusPriority: 22,
    },
  ] as Status[]

  inProgressStatuses = [
    {
      id: "IN_OPS",
      label: "In Ops",
      statusPriority: 16,
    },
    {
      id: "IN_UI_UX",
      label: "In UI/UX",
      statusPriority: 14,
    },
    {
      id: "IN_DESIGN",
      label: "In Design",
      statusPriority: 12,
    },
    {
      id: "IN_DEVELOPMENT",
      label: "In Development",
      statusPriority: 10,
    },
    {
      id: "IN_QA",
      label: "In QA",
      statusPriority: 8,
    },
    {
      id: "SCHEDULED_FOR_DEPLOYMENT",
      label: "Scheduled for Deployment",
      statusPriority: 6,
    },
    {
      id: "DEPLOYED_TO_STAGING",
      label: "In Staging",
      statusPriority: 5,
    },
    {
      id: "DEPLOYED_TO_PRODUCTION",
      label: "In Production",
      statusPriority: 4,
    },
    {
     id: "CLIENT_REVIEW",
     label: "Client Review",
      statusPriority: 20,
    },
    {
     id: "PM_REVIEW",
     label: "PM Review",
      statusPriority: 21,
    },
    {
      id: "IN_PROGRESS",
      label: "Start",
      statusPriority: 19,
    },
    {
     id: "IN_RESEARCH",
     label: "Research",
      statusPriority: 31,
    },
    {
     id: "CONTENT_CREATING",
     label: "Content",
      statusPriority: 29,
    },
    {
     id: "IN_GRAPHIC_DESIGN",
     label: "Graphic Design",
      statusPriority: 27,
    },
    {
     id: "IN_SEO",
     label: "SEO",
      statusPriority: 25,
    },
    {
     id: "IN_SMM",
     label: "SMM",
      statusPriority: 23,
    },
    {
     id: "IN_DISCOVERY",
     label: "Discovery",
      statusPriority: 22,
    },
    { id: "IN_UX", label: "In UX", statusPriority: 17 },
    { id: "IN_UI_DESIGN", label: "In UI Design", statusPriority: 15 },
    { id: "TESTING", label: "Testing", statusPriority: 13 },
    { id: "DELIVERY", label: "Delivery", statusPriority: 11 },
    { id: "DEV_HANDOFF", label: "Dev Handoff", statusPriority: 9 },
    { id: "INFRASTRUCTURE", label: "Infrastructure", statusPriority: 17 },
    { id: "CI_CD_PIPELINE", label: "CI/CD Pipeline", statusPriority: 15 },
    { id: "SECURITY", label: "Security", statusPriority: 13 },
    { id: "MITIGATION", label: "Mitigation", statusPriority: 12 },
    { id: "REMEDIATING", label: "Remediating", statusPriority: 11 },
    { id: "IN_TESTING", label: "In Testing", statusPriority: 10 },
    { id: "IN_REVIEW", label: "In Review", statusPriority: 9 },
    { id: "OBSERVABILITY", label: "Observability", statusPriority: 11 },
    { id: "ALERTING", label: "Alerting", statusPriority: 9 },
    { id: "PERFORMANCE", label: "Performance", statusPriority: 7 },
    { id: "COST_OPTIMIZATION", label: "Cost Optimization", statusPriority: 5 },
    { id: "DOCUMENTATION", label: "Documentation", statusPriority: 3 },
  ] as Status[]

  get [`get/${ItemStatusActions.GET_STATUSES}`]() {
    return this.statuses.filter(a => a.id !== "UNBLOCKED" && a.id !== "RESUME" && a.id !== "RESTORE")
  }

  get [`get/${ItemStatusActions.GET_IN_PROGRESS_STATUSES}`]() {
    return this.inProgressStatuses
  }

  get [`get/${ItemStatusActions.GET_STATUSES_FOR_FILTER}`]() {
    return [
      {
        id: "NOT_STARTED",
        label: "Not Started",
        statusPriority: 1,
      },
      {
        id: "BLOCKED",
        label: "Blocked",
        statusPriority: 3,
      },
      {
        id: "UNBLOCKED",
        label: "Unblocked",
        statusPriority: 4,
      },
      {
        id: "OBSOLETE",
        label: "Obsolete",
        statusPriority: 5,
      },
      {
        id: "RE_OPEN",
        label: "Re-Open",
        statusPriority: 5,
      },
      {
        id: "DONE",
        label: "Done",
        statusPriority: 6,
      },
    ]
  }

  get [`get/${ItemStatusActions.GET_STATUSES_FOR_PRODUCT_BACKLOG_FILTER}`]() {
    return [
      {
        id: "NOT_STARTED",
        label: "Not Started",
        statusPriority: 1,
      },
      {
        id: "IN_PROGRESS",
        label: "In Progress",
        statusPriority: 2
      },
      {
        id: "IN_REVIEW",
        label: "In Review",
        statusPriority: 3,
      },
      {
        id: "BLOCKED",
        label: "Blocked",
        statusPriority: 5,
      },
      {
        id: "UNBLOCKED",
        label: "Unblocked",
        statusPriority: 6,
      },
      {
        id: "OBSOLETE",
        label: "Obsolete",
        statusPriority: 7,
      },
      {
        id: "RE_OPEN",
        label: "Re-Open",
        statusPriority: 7,
      },
      {
        id: "DONE",
        label: "Done",
        statusPriority: 8,
      },
    ]
  }

  get [`get/${ItemStatusActions.GET_STATUS_BY_ID}`]() {
    return (id: string) => {
      const item = this.statuses.find((status: Status) => status.id === id)
      return item ? item : { id: "", label: "" }
    }
  }

  get [`get/${ItemStatusActions.GET_STATUS_BY_IDS}`]() {
    return (ids: string[]) => this.statuses.filter(status => ids.includes(status.id))
  }
}

export const itemStatusModule = new ItemStatusModule({
  store,
  name: Modules.ITEM_STATUS,
})
